var _slicedToArray = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    join = _require$doc$builders.join;

var ImportDirective = {
  print: function print(_ref) {
    var node = _ref.node;
    // @TODO: handle proper escaping
    var doc = concat(['"', node.path, '"']);

    if (node.unitAlias) {
      doc = concat([doc, ' as ', node.unitAlias]);
    } else if (node.symbolAliases) {
      doc = concat(['{', join(', ', node.symbolAliases.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            a = _ref3[0],
            b = _ref3[1];

        return b ? [a, b].join(' as ') : a;
      })), '} from ', doc]);
    }

    return concat(['import ', doc, ';']);
  }
};
module.exports = ImportDirective;